import { generateErrorMap } from "@saberhq/anchor-contrib";

export type TransferWrapperIDL = {
  version: "1.0.0";
  name: "transfer_wrapper";
  instructions: [
    {
      name: "newWrapper";
      accounts: [
        {
          name: "base";
          isMut: false;
          isSigner: true;
        },
        {
          name: "transferWrapper";
          isMut: true;
          isSigner: false;
        },
        {
          name: "admin";
          isMut: false;
          isSigner: false;
        },
        {
          name: "tokenMint";
          isMut: false;
          isSigner: false;
        },
        {
          name: "sourceTokenAccount";
          isMut: false;
          isSigner: false;
        },
        {
          name: "tokenProgram";
          isMut: false;
          isSigner: false;
        },
        {
          name: "payer";
          isMut: true;
          isSigner: true;
        },
        {
          name: "systemProgram";
          isMut: false;
          isSigner: false;
        }
      ];
      args: [
        {
          name: "bump";
          type: "u8";
        }
      ];
    },
    {
      name: "transferAdmin";
      accounts: [
        {
          name: "transferWrapper";
          isMut: true;
          isSigner: false;
        },
        {
          name: "admin";
          isMut: false;
          isSigner: true;
        },
        {
          name: "nextAdmin";
          isMut: false;
          isSigner: false;
        }
      ];
      args: [];
    },
    {
      name: "acceptAdmin";
      accounts: [
        {
          name: "transferWrapper";
          isMut: true;
          isSigner: false;
        },
        {
          name: "pendingAdmin";
          isMut: false;
          isSigner: true;
        }
      ];
      args: [];
    },
    {
      name: "newTransferer";
      accounts: [
        {
          name: "auth";
          accounts: [
            {
              name: "transferWrapper";
              isMut: true;
              isSigner: false;
            },
            {
              name: "admin";
              isMut: false;
              isSigner: true;
            }
          ];
        },
        {
          name: "transferAuthority";
          isMut: false;
          isSigner: false;
        },
        {
          name: "transferer";
          isMut: true;
          isSigner: false;
        },
        {
          name: "payer";
          isMut: true;
          isSigner: true;
        },
        {
          name: "systemProgram";
          isMut: false;
          isSigner: false;
        }
      ];
      args: [
        {
          name: "bump";
          type: "u8";
        }
      ];
    },
    {
      name: "transferUpdate";
      accounts: [
        {
          name: "auth";
          accounts: [
            {
              name: "transferWrapper";
              isMut: true;
              isSigner: false;
            },
            {
              name: "admin";
              isMut: false;
              isSigner: true;
            }
          ];
        },
        {
          name: "transferer";
          isMut: true;
          isSigner: false;
        },
        {
          name: "sourceTokenAccount";
          isMut: false;
          isSigner: false;
        }
      ];
      args: [
        {
          name: "allowance";
          type: "u64";
        }
      ];
    },
    {
      name: "updateCap";
      accounts: [
        {
          name: "auth";
          accounts: [
            {
              name: "transferWrapper";
              isMut: true;
              isSigner: false;
            },
            {
              name: "admin";
              isMut: false;
              isSigner: true;
            }
          ];
        },
        {
          name: "sourceTokenAccount";
          isMut: false;
          isSigner: false;
        }
      ];
      args: [
        {
          name: "cap";
          type: "u64";
        }
      ];
    },
    {
      name: "performTransfer";
      accounts: [
        {
          name: "transferWrapper";
          isMut: true;
          isSigner: false;
        },
        {
          name: "transfererAuthority";
          isMut: false;
          isSigner: true;
        },
        {
          name: "tokenMint";
          isMut: false;
          isSigner: false;
        },
        {
          name: "destination";
          isMut: true;
          isSigner: false;
        },
        {
          name: "transferer";
          isMut: true;
          isSigner: false;
        },
        {
          name: "sourceTokenAccount";
          isMut: true;
          isSigner: false;
        },
        {
          name: "tokenProgram";
          isMut: false;
          isSigner: false;
        }
      ];
      args: [
        {
          name: "amount";
          type: "u64";
        }
      ];
    },
    {
      name: "withdraw";
      accounts: [
        {
          name: "auth";
          accounts: [
            {
              name: "transferWrapper";
              isMut: true;
              isSigner: false;
            },
            {
              name: "admin";
              isMut: false;
              isSigner: true;
            }
          ];
        },
        {
          name: "sourceTokenAccount";
          isMut: false;
          isSigner: false;
        },
        {
          name: "destTokenAccount";
          isMut: false;
          isSigner: false;
        },
        {
          name: "tokenProgram";
          isMut: false;
          isSigner: false;
        }
      ];
      args: [];
    }
  ];
  accounts: [
    {
      name: "TransferWrapper";
      type: {
        kind: "struct";
        fields: [
          {
            name: "base";
            type: "publicKey";
          },
          {
            name: "bump";
            type: "u8";
          },
          {
            name: "admin";
            type: "publicKey";
          },
          {
            name: "pendingAdmin";
            type: "publicKey";
          },
          {
            name: "tokenMint";
            type: "publicKey";
          },
          {
            name: "numTransfers";
            type: "u64";
          },
          {
            name: "cap";
            type: "u64";
          },
          {
            name: "totalAllowance";
            type: "u64";
          },
          {
            name: "totalTransfered";
            type: "u64";
          },
          {
            name: "sourceTokenAccount";
            type: "publicKey";
          }
        ];
      };
    },
    {
      name: "Transferer";
      type: {
        kind: "struct";
        fields: [
          {
            name: "transferWrapper";
            type: "publicKey";
          },
          {
            name: "transferAuthority";
            type: "publicKey";
          },
          {
            name: "bump";
            type: "u8";
          },
          {
            name: "index";
            type: "u64";
          },
          {
            name: "allowance";
            type: "u64";
          },
          {
            name: "totalTransfered";
            type: "u64";
          }
        ];
      };
    }
  ];
  events: [
    {
      name: "NewTransferWrapperEvent";
      fields: [
        {
          name: "transferWrapper";
          type: "publicKey";
          index: false;
        },
        {
          name: "admin";
          type: "publicKey";
          index: false;
        },
        {
          name: "tokenMint";
          type: "publicKey";
          index: false;
        },
        {
          name: "sourceTokenAccount";
          type: "publicKey";
          index: false;
        }
      ];
    },
    {
      name: "TransferWrapperAdminProposeEvent";
      fields: [
        {
          name: "transferWrapper";
          type: "publicKey";
          index: false;
        },
        {
          name: "currentAdmin";
          type: "publicKey";
          index: false;
        },
        {
          name: "pendingAdmin";
          type: "publicKey";
          index: false;
        }
      ];
    },
    {
      name: "TransferWrapperAdminUpdateEvent";
      fields: [
        {
          name: "transferWrapper";
          type: "publicKey";
          index: false;
        },
        {
          name: "previousAdmin";
          type: "publicKey";
          index: false;
        },
        {
          name: "admin";
          type: "publicKey";
          index: false;
        }
      ];
    },
    {
      name: "NewTransferEvent";
      fields: [
        {
          name: "transferWrapper";
          type: "publicKey";
          index: false;
        },
        {
          name: "transferer";
          type: "publicKey";
          index: false;
        },
        {
          name: "index";
          type: "u64";
          index: false;
        },
        {
          name: "transferAuthority";
          type: "publicKey";
          index: false;
        }
      ];
    },
    {
      name: "TransfererAllowanceUpdateEvent";
      fields: [
        {
          name: "transferWrapper";
          type: "publicKey";
          index: false;
        },
        {
          name: "transferer";
          type: "publicKey";
          index: false;
        },
        {
          name: "previousAllowance";
          type: "u64";
          index: false;
        },
        {
          name: "allowance";
          type: "u64";
          index: false;
        }
      ];
    },
    {
      name: "TransferEvent";
      fields: [
        {
          name: "transferWrapper";
          type: "publicKey";
          index: false;
        },
        {
          name: "transferer";
          type: "publicKey";
          index: false;
        },
        {
          name: "amount";
          type: "u64";
          index: false;
        },
        {
          name: "destination";
          type: "publicKey";
          index: false;
        }
      ];
    }
  ];
  errors: [
    {
      code: 6000;
      name: "Unauthorized";
      msg: "You are not authorized to perform this action.";
    },
    {
      code: 6001;
      name: "AmountLessThanCap";
      msg: "Source token acount amount less than cap";
    },
    {
      code: 6002;
      name: "AllowanceOverTokenAmount";
      msg: "Cannot allowance over source token amount.";
    },
    {
      code: 6003;
      name: "TransferAllowanceExceeded";
      msg: "Transfer allowance exceeded.";
    }
  ];
};
export type AnchorTransferWrapper = {
  version: "1.0.0";
  name: "transfer_wrapper";
  instructions: [
    {
      name: "newWrapper";
      accounts: [
        {
          name: "base";
          isMut: false;
          isSigner: true;
        },
        {
          name: "transferWrapper";
          isMut: true;
          isSigner: false;
        },
        {
          name: "admin";
          isMut: false;
          isSigner: false;
        },
        {
          name: "tokenMint";
          isMut: false;
          isSigner: false;
        },
        {
          name: "sourceTokenAccount";
          isMut: false;
          isSigner: false;
        },
        {
          name: "tokenProgram";
          isMut: false;
          isSigner: false;
        },
        {
          name: "payer";
          isMut: true;
          isSigner: true;
        },
        {
          name: "systemProgram";
          isMut: false;
          isSigner: false;
        }
      ];
      args: [
        {
          name: "bump";
          type: "u8";
        }
      ];
    },
    {
      name: "transferAdmin";
      accounts: [
        {
          name: "transferWrapper";
          isMut: true;
          isSigner: false;
        },
        {
          name: "admin";
          isMut: false;
          isSigner: true;
        },
        {
          name: "nextAdmin";
          isMut: false;
          isSigner: false;
        }
      ];
      args: [];
    },
    {
      name: "acceptAdmin";
      accounts: [
        {
          name: "transferWrapper";
          isMut: true;
          isSigner: false;
        },
        {
          name: "pendingAdmin";
          isMut: false;
          isSigner: true;
        }
      ];
      args: [];
    },
    {
      name: "newTransferer";
      accounts: [
        {
          name: "auth";
          accounts: [
            {
              name: "transferWrapper";
              isMut: true;
              isSigner: false;
            },
            {
              name: "admin";
              isMut: false;
              isSigner: true;
            }
          ];
        },
        {
          name: "transferAuthority";
          isMut: false;
          isSigner: false;
        },
        {
          name: "transferer";
          isMut: true;
          isSigner: false;
        },
        {
          name: "payer";
          isMut: true;
          isSigner: true;
        },
        {
          name: "systemProgram";
          isMut: false;
          isSigner: false;
        }
      ];
      args: [
        {
          name: "bump";
          type: "u8";
        }
      ];
    },
    {
      name: "transferUpdate";
      accounts: [
        {
          name: "auth";
          accounts: [
            {
              name: "transferWrapper";
              isMut: true;
              isSigner: false;
            },
            {
              name: "admin";
              isMut: false;
              isSigner: true;
            }
          ];
        },
        {
          name: "transferer";
          isMut: true;
          isSigner: false;
        },
        {
          name: "sourceTokenAccount";
          isMut: false;
          isSigner: false;
        }
      ];
      args: [
        {
          name: "allowance";
          type: "u64";
        }
      ];
    },
    {
      name: "updateCap";
      accounts: [
        {
          name: "auth";
          accounts: [
            {
              name: "transferWrapper";
              isMut: true;
              isSigner: false;
            },
            {
              name: "admin";
              isMut: false;
              isSigner: true;
            }
          ];
        },
        {
          name: "sourceTokenAccount";
          isMut: false;
          isSigner: false;
        }
      ];
      args: [
        {
          name: "cap";
          type: "u64";
        }
      ];
    },
    {
      name: "performTransfer";
      accounts: [
        {
          name: "transferWrapper";
          isMut: true;
          isSigner: false;
        },
        {
          name: "transfererAuthority";
          isMut: false;
          isSigner: true;
        },
        {
          name: "tokenMint";
          isMut: false;
          isSigner: false;
        },
        {
          name: "destination";
          isMut: true;
          isSigner: false;
        },
        {
          name: "transferer";
          isMut: true;
          isSigner: false;
        },
        {
          name: "sourceTokenAccount";
          isMut: true;
          isSigner: false;
        },
        {
          name: "tokenProgram";
          isMut: false;
          isSigner: false;
        }
      ];
      args: [
        {
          name: "amount";
          type: "u64";
        }
      ];
    },
    {
      name: "withdraw";
      accounts: [
        {
          name: "auth";
          accounts: [
            {
              name: "transferWrapper";
              isMut: true;
              isSigner: false;
            },
            {
              name: "admin";
              isMut: false;
              isSigner: true;
            }
          ];
        },
        {
          name: "sourceTokenAccount";
          isMut: false;
          isSigner: false;
        },
        {
          name: "destTokenAccount";
          isMut: false;
          isSigner: false;
        },
        {
          name: "tokenProgram";
          isMut: false;
          isSigner: false;
        }
      ];
      args: [];
    }
  ];
  accounts: [
    {
      name: "transferWrapper";
      type: {
        kind: "struct";
        fields: [
          {
            name: "base";
            type: "publicKey";
          },
          {
            name: "bump";
            type: "u8";
          },
          {
            name: "admin";
            type: "publicKey";
          },
          {
            name: "pendingAdmin";
            type: "publicKey";
          },
          {
            name: "tokenMint";
            type: "publicKey";
          },
          {
            name: "numTransfers";
            type: "u64";
          },
          {
            name: "cap";
            type: "u64";
          },
          {
            name: "totalAllowance";
            type: "u64";
          },
          {
            name: "totalTransfered";
            type: "u64";
          },
          {
            name: "sourceTokenAccount";
            type: "publicKey";
          }
        ];
      };
    },
    {
      name: "transferer";
      type: {
        kind: "struct";
        fields: [
          {
            name: "transferWrapper";
            type: "publicKey";
          },
          {
            name: "transferAuthority";
            type: "publicKey";
          },
          {
            name: "bump";
            type: "u8";
          },
          {
            name: "index";
            type: "u64";
          },
          {
            name: "allowance";
            type: "u64";
          },
          {
            name: "totalTransfered";
            type: "u64";
          }
        ];
      };
    }
  ];
  events: [
    {
      name: "NewAnchorTransferWrapperEvent";
      fields: [
        {
          name: "transferWrapper";
          type: "publicKey";
          index: false;
        },
        {
          name: "admin";
          type: "publicKey";
          index: false;
        },
        {
          name: "tokenMint";
          type: "publicKey";
          index: false;
        },
        {
          name: "sourceTokenAccount";
          type: "publicKey";
          index: false;
        }
      ];
    },
    {
      name: "AnchorTransferWrapperAdminProposeEvent";
      fields: [
        {
          name: "transferWrapper";
          type: "publicKey";
          index: false;
        },
        {
          name: "currentAdmin";
          type: "publicKey";
          index: false;
        },
        {
          name: "pendingAdmin";
          type: "publicKey";
          index: false;
        }
      ];
    },
    {
      name: "AnchorTransferWrapperAdminUpdateEvent";
      fields: [
        {
          name: "transferWrapper";
          type: "publicKey";
          index: false;
        },
        {
          name: "previousAdmin";
          type: "publicKey";
          index: false;
        },
        {
          name: "admin";
          type: "publicKey";
          index: false;
        }
      ];
    },
    {
      name: "NewTransferEvent";
      fields: [
        {
          name: "transferWrapper";
          type: "publicKey";
          index: false;
        },
        {
          name: "transferer";
          type: "publicKey";
          index: false;
        },
        {
          name: "index";
          type: "u64";
          index: false;
        },
        {
          name: "transferAuthority";
          type: "publicKey";
          index: false;
        }
      ];
    },
    {
      name: "TransfererAllowanceUpdateEvent";
      fields: [
        {
          name: "transferWrapper";
          type: "publicKey";
          index: false;
        },
        {
          name: "transferer";
          type: "publicKey";
          index: false;
        },
        {
          name: "previousAllowance";
          type: "u64";
          index: false;
        },
        {
          name: "allowance";
          type: "u64";
          index: false;
        }
      ];
    },
    {
      name: "TransferEvent";
      fields: [
        {
          name: "transferWrapper";
          type: "publicKey";
          index: false;
        },
        {
          name: "transferer";
          type: "publicKey";
          index: false;
        },
        {
          name: "amount";
          type: "u64";
          index: false;
        },
        {
          name: "destination";
          type: "publicKey";
          index: false;
        }
      ];
    }
  ];
  errors: [
    {
      code: 6000;
      name: "Unauthorized";
      msg: "You are not authorized to perform this action.";
    },
    {
      code: 6001;
      name: "AmountLessThanCap";
      msg: "Source token acount amount less than cap";
    },
    {
      code: 6002;
      name: "AllowanceOverTokenAmount";
      msg: "Cannot allowance over source token amount.";
    },
    {
      code: 6003;
      name: "TransferAllowanceExceeded";
      msg: "Transfer allowance exceeded.";
    }
  ];
};

export const AnchorTransferWrapperIDL: AnchorTransferWrapper = {
  version: "1.0.0",
  name: "transfer_wrapper",
  instructions: [
    {
      name: "newWrapper",
      accounts: [
        {
          name: "base",
          isMut: false,
          isSigner: true,
        },
        {
          name: "transferWrapper",
          isMut: true,
          isSigner: false,
        },
        {
          name: "admin",
          isMut: false,
          isSigner: false,
        },
        {
          name: "tokenMint",
          isMut: false,
          isSigner: false,
        },
        {
          name: "sourceTokenAccount",
          isMut: false,
          isSigner: false,
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [
        {
          name: "bump",
          type: "u8",
        },
      ],
    },
    {
      name: "transferAdmin",
      accounts: [
        {
          name: "transferWrapper",
          isMut: true,
          isSigner: false,
        },
        {
          name: "admin",
          isMut: false,
          isSigner: true,
        },
        {
          name: "nextAdmin",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [],
    },
    {
      name: "acceptAdmin",
      accounts: [
        {
          name: "transferWrapper",
          isMut: true,
          isSigner: false,
        },
        {
          name: "pendingAdmin",
          isMut: false,
          isSigner: true,
        },
      ],
      args: [],
    },
    {
      name: "newTransferer",
      accounts: [
        {
          name: "auth",
          accounts: [
            {
              name: "transferWrapper",
              isMut: true,
              isSigner: false,
            },
            {
              name: "admin",
              isMut: false,
              isSigner: true,
            },
          ],
        },
        {
          name: "transferAuthority",
          isMut: false,
          isSigner: false,
        },
        {
          name: "transferer",
          isMut: true,
          isSigner: false,
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [
        {
          name: "bump",
          type: "u8",
        },
      ],
    },
    {
      name: "transferUpdate",
      accounts: [
        {
          name: "auth",
          accounts: [
            {
              name: "transferWrapper",
              isMut: true,
              isSigner: false,
            },
            {
              name: "admin",
              isMut: false,
              isSigner: true,
            },
          ],
        },
        {
          name: "transferer",
          isMut: true,
          isSigner: false,
        },
        {
          name: "sourceTokenAccount",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [
        {
          name: "allowance",
          type: "u64",
        },
      ],
    },
    {
      name: "updateCap",
      accounts: [
        {
          name: "auth",
          accounts: [
            {
              name: "transferWrapper",
              isMut: true,
              isSigner: false,
            },
            {
              name: "admin",
              isMut: false,
              isSigner: true,
            },
          ],
        },
        {
          name: "sourceTokenAccount",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [
        {
          name: "cap",
          type: "u64",
        },
      ],
    },
    {
      name: "performTransfer",
      accounts: [
        {
          name: "transferWrapper",
          isMut: true,
          isSigner: false,
        },
        {
          name: "transfererAuthority",
          isMut: false,
          isSigner: true,
        },
        {
          name: "tokenMint",
          isMut: false,
          isSigner: false,
        },
        {
          name: "destination",
          isMut: true,
          isSigner: false,
        },
        {
          name: "transferer",
          isMut: true,
          isSigner: false,
        },
        {
          name: "sourceTokenAccount",
          isMut: true,
          isSigner: false,
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [
        {
          name: "amount",
          type: "u64",
        },
      ],
    },
    {
      name: "withdraw",
      accounts: [
        {
          name: "auth",
          accounts: [
            {
              name: "transferWrapper",
              isMut: true,
              isSigner: false,
            },
            {
              name: "admin",
              isMut: false,
              isSigner: true,
            },
          ],
        },
        {
          name: "sourceTokenAccount",
          isMut: false,
          isSigner: false,
        },
        {
          name: "destTokenAccount",
          isMut: false,
          isSigner: false,
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [],
    },
  ],
  accounts: [
    {
      name: "transferWrapper",
      type: {
        kind: "struct",
        fields: [
          {
            name: "base",
            type: "publicKey",
          },
          {
            name: "bump",
            type: "u8",
          },
          {
            name: "admin",
            type: "publicKey",
          },
          {
            name: "pendingAdmin",
            type: "publicKey",
          },
          {
            name: "tokenMint",
            type: "publicKey",
          },
          {
            name: "numTransfers",
            type: "u64",
          },
          {
            name: "cap",
            type: "u64",
          },
          {
            name: "totalAllowance",
            type: "u64",
          },
          {
            name: "totalTransfered",
            type: "u64",
          },
          {
            name: "sourceTokenAccount",
            type: "publicKey",
          },
        ],
      },
    },
    {
      name: "transferer",
      type: {
        kind: "struct",
        fields: [
          {
            name: "transferWrapper",
            type: "publicKey",
          },
          {
            name: "transferAuthority",
            type: "publicKey",
          },
          {
            name: "bump",
            type: "u8",
          },
          {
            name: "index",
            type: "u64",
          },
          {
            name: "allowance",
            type: "u64",
          },
          {
            name: "totalTransfered",
            type: "u64",
          },
        ],
      },
    },
  ],
  events: [
    {
      name: "NewAnchorTransferWrapperEvent",
      fields: [
        {
          name: "transferWrapper",
          type: "publicKey",
          index: false,
        },
        {
          name: "admin",
          type: "publicKey",
          index: false,
        },
        {
          name: "tokenMint",
          type: "publicKey",
          index: false,
        },
        {
          name: "sourceTokenAccount",
          type: "publicKey",
          index: false,
        },
      ],
    },
    {
      name: "AnchorTransferWrapperAdminProposeEvent",
      fields: [
        {
          name: "transferWrapper",
          type: "publicKey",
          index: false,
        },
        {
          name: "currentAdmin",
          type: "publicKey",
          index: false,
        },
        {
          name: "pendingAdmin",
          type: "publicKey",
          index: false,
        },
      ],
    },
    {
      name: "AnchorTransferWrapperAdminUpdateEvent",
      fields: [
        {
          name: "transferWrapper",
          type: "publicKey",
          index: false,
        },
        {
          name: "previousAdmin",
          type: "publicKey",
          index: false,
        },
        {
          name: "admin",
          type: "publicKey",
          index: false,
        },
      ],
    },
    {
      name: "NewTransferEvent",
      fields: [
        {
          name: "transferWrapper",
          type: "publicKey",
          index: false,
        },
        {
          name: "transferer",
          type: "publicKey",
          index: false,
        },
        {
          name: "index",
          type: "u64",
          index: false,
        },
        {
          name: "transferAuthority",
          type: "publicKey",
          index: false,
        },
      ],
    },
    {
      name: "TransfererAllowanceUpdateEvent",
      fields: [
        {
          name: "transferWrapper",
          type: "publicKey",
          index: false,
        },
        {
          name: "transferer",
          type: "publicKey",
          index: false,
        },
        {
          name: "previousAllowance",
          type: "u64",
          index: false,
        },
        {
          name: "allowance",
          type: "u64",
          index: false,
        },
      ],
    },
    {
      name: "TransferEvent",
      fields: [
        {
          name: "transferWrapper",
          type: "publicKey",
          index: false,
        },
        {
          name: "transferer",
          type: "publicKey",
          index: false,
        },
        {
          name: "amount",
          type: "u64",
          index: false,
        },
        {
          name: "destination",
          type: "publicKey",
          index: false,
        },
      ],
    },
  ],
  errors: [
    {
      code: 6000,
      name: "Unauthorized",
      msg: "You are not authorized to perform this action.",
    },
    {
      code: 6001,
      name: "AmountLessThanCap",
      msg: "Source token acount amount less than cap",
    },
    {
      code: 6002,
      name: "AllowanceOverTokenAmount",
      msg: "Cannot allowance over source token amount.",
    },
    {
      code: 6003,
      name: "TransferAllowanceExceeded",
      msg: "Transfer allowance exceeded.",
    },
  ],
};
export const TransferWrapperJSON: TransferWrapperIDL = {
  version: "1.0.0",
  name: "transfer_wrapper",
  instructions: [
    {
      name: "newWrapper",
      accounts: [
        {
          name: "base",
          isMut: false,
          isSigner: true,
        },
        {
          name: "transferWrapper",
          isMut: true,
          isSigner: false,
        },
        {
          name: "admin",
          isMut: false,
          isSigner: false,
        },
        {
          name: "tokenMint",
          isMut: false,
          isSigner: false,
        },
        {
          name: "sourceTokenAccount",
          isMut: false,
          isSigner: false,
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [
        {
          name: "bump",
          type: "u8",
        },
      ],
    },
    {
      name: "transferAdmin",
      accounts: [
        {
          name: "transferWrapper",
          isMut: true,
          isSigner: false,
        },
        {
          name: "admin",
          isMut: false,
          isSigner: true,
        },
        {
          name: "nextAdmin",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [],
    },
    {
      name: "acceptAdmin",
      accounts: [
        {
          name: "transferWrapper",
          isMut: true,
          isSigner: false,
        },
        {
          name: "pendingAdmin",
          isMut: false,
          isSigner: true,
        },
      ],
      args: [],
    },
    {
      name: "newTransferer",
      accounts: [
        {
          name: "auth",
          accounts: [
            {
              name: "transferWrapper",
              isMut: true,
              isSigner: false,
            },
            {
              name: "admin",
              isMut: false,
              isSigner: true,
            },
          ],
        },
        {
          name: "transferAuthority",
          isMut: false,
          isSigner: false,
        },
        {
          name: "transferer",
          isMut: true,
          isSigner: false,
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [
        {
          name: "bump",
          type: "u8",
        },
      ],
    },
    {
      name: "transferUpdate",
      accounts: [
        {
          name: "auth",
          accounts: [
            {
              name: "transferWrapper",
              isMut: true,
              isSigner: false,
            },
            {
              name: "admin",
              isMut: false,
              isSigner: true,
            },
          ],
        },
        {
          name: "transferer",
          isMut: true,
          isSigner: false,
        },
        {
          name: "sourceTokenAccount",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [
        {
          name: "allowance",
          type: "u64",
        },
      ],
    },
    {
      name: "updateCap",
      accounts: [
        {
          name: "auth",
          accounts: [
            {
              name: "transferWrapper",
              isMut: true,
              isSigner: false,
            },
            {
              name: "admin",
              isMut: false,
              isSigner: true,
            },
          ],
        },
        {
          name: "sourceTokenAccount",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [
        {
          name: "cap",
          type: "u64",
        },
      ],
    },
    {
      name: "performTransfer",
      accounts: [
        {
          name: "transferWrapper",
          isMut: true,
          isSigner: false,
        },
        {
          name: "transfererAuthority",
          isMut: false,
          isSigner: true,
        },
        {
          name: "tokenMint",
          isMut: false,
          isSigner: false,
        },
        {
          name: "destination",
          isMut: true,
          isSigner: false,
        },
        {
          name: "transferer",
          isMut: true,
          isSigner: false,
        },
        {
          name: "sourceTokenAccount",
          isMut: true,
          isSigner: false,
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [
        {
          name: "amount",
          type: "u64",
        },
      ],
    },
    {
      name: "withdraw",
      accounts: [
        {
          name: "auth",
          accounts: [
            {
              name: "transferWrapper",
              isMut: true,
              isSigner: false,
            },
            {
              name: "admin",
              isMut: false,
              isSigner: true,
            },
          ],
        },
        {
          name: "sourceTokenAccount",
          isMut: false,
          isSigner: false,
        },
        {
          name: "destTokenAccount",
          isMut: false,
          isSigner: false,
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [],
    },
  ],
  accounts: [
    {
      name: "TransferWrapper",
      type: {
        kind: "struct",
        fields: [
          {
            name: "base",
            type: "publicKey",
          },
          {
            name: "bump",
            type: "u8",
          },
          {
            name: "admin",
            type: "publicKey",
          },
          {
            name: "pendingAdmin",
            type: "publicKey",
          },
          {
            name: "tokenMint",
            type: "publicKey",
          },
          {
            name: "numTransfers",
            type: "u64",
          },
          {
            name: "cap",
            type: "u64",
          },
          {
            name: "totalAllowance",
            type: "u64",
          },
          {
            name: "totalTransfered",
            type: "u64",
          },
          {
            name: "sourceTokenAccount",
            type: "publicKey",
          },
        ],
      },
    },
    {
      name: "Transferer",
      type: {
        kind: "struct",
        fields: [
          {
            name: "transferWrapper",
            type: "publicKey",
          },
          {
            name: "transferAuthority",
            type: "publicKey",
          },
          {
            name: "bump",
            type: "u8",
          },
          {
            name: "index",
            type: "u64",
          },
          {
            name: "allowance",
            type: "u64",
          },
          {
            name: "totalTransfered",
            type: "u64",
          },
        ],
      },
    },
  ],
  events: [
    {
      name: "NewTransferWrapperEvent",
      fields: [
        {
          name: "transferWrapper",
          type: "publicKey",
          index: false,
        },
        {
          name: "admin",
          type: "publicKey",
          index: false,
        },
        {
          name: "tokenMint",
          type: "publicKey",
          index: false,
        },
        {
          name: "sourceTokenAccount",
          type: "publicKey",
          index: false,
        },
      ],
    },
    {
      name: "TransferWrapperAdminProposeEvent",
      fields: [
        {
          name: "transferWrapper",
          type: "publicKey",
          index: false,
        },
        {
          name: "currentAdmin",
          type: "publicKey",
          index: false,
        },
        {
          name: "pendingAdmin",
          type: "publicKey",
          index: false,
        },
      ],
    },
    {
      name: "TransferWrapperAdminUpdateEvent",
      fields: [
        {
          name: "transferWrapper",
          type: "publicKey",
          index: false,
        },
        {
          name: "previousAdmin",
          type: "publicKey",
          index: false,
        },
        {
          name: "admin",
          type: "publicKey",
          index: false,
        },
      ],
    },
    {
      name: "NewTransferEvent",
      fields: [
        {
          name: "transferWrapper",
          type: "publicKey",
          index: false,
        },
        {
          name: "transferer",
          type: "publicKey",
          index: false,
        },
        {
          name: "index",
          type: "u64",
          index: false,
        },
        {
          name: "transferAuthority",
          type: "publicKey",
          index: false,
        },
      ],
    },
    {
      name: "TransfererAllowanceUpdateEvent",
      fields: [
        {
          name: "transferWrapper",
          type: "publicKey",
          index: false,
        },
        {
          name: "transferer",
          type: "publicKey",
          index: false,
        },
        {
          name: "previousAllowance",
          type: "u64",
          index: false,
        },
        {
          name: "allowance",
          type: "u64",
          index: false,
        },
      ],
    },
    {
      name: "TransferEvent",
      fields: [
        {
          name: "transferWrapper",
          type: "publicKey",
          index: false,
        },
        {
          name: "transferer",
          type: "publicKey",
          index: false,
        },
        {
          name: "amount",
          type: "u64",
          index: false,
        },
        {
          name: "destination",
          type: "publicKey",
          index: false,
        },
      ],
    },
  ],
  errors: [
    {
      code: 6000,
      name: "Unauthorized",
      msg: "You are not authorized to perform this action.",
    },
    {
      code: 6001,
      name: "AmountLessThanCap",
      msg: "Source token acount amount less than cap",
    },
    {
      code: 6002,
      name: "AllowanceOverTokenAmount",
      msg: "Cannot allowance over source token amount.",
    },
    {
      code: 6003,
      name: "TransferAllowanceExceeded",
      msg: "Transfer allowance exceeded.",
    },
  ],
};
export const TransferWrapperErrors = generateErrorMap(TransferWrapperJSON);
